<form #form="ngForm" (submit)="onSave()" class="cadastro-form">
  <mat-form-field class="fullwidth" appearance="outline"  [class.error-margin]="inputNome.touched && inputNome?.errors">
    <mat-label>Nome</mat-label>
    <input
      matInput
      name="inputNome"
      #inputNome="ngModel"
      [(ngModel)]="usuario.nome"
      class="custom-input"
      placeholder="Seu Nome" 
      autocomplete="off"
      maxlength="200"
      required>
    <mat-error *ngIf="inputNome.touched && inputNome?.errors">
      Este campo é obrigatório!
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputCpf.touched && inputCpf?.errors">
    <mat-label>CPF</mat-label>
    <input
      [disabled]="disableCpf"
      name="inputCpf"
      #inputCpf="ngModel"
      [(ngModel)]="usuario.cpf"
      mascara="000.000.000-00"
      [modelSemMascara]="true"
      class="custom-input"
      matInput
      document-validator
      placeholder="000.000.000-00" 
      autocomplete="off"
      required>
    <mat-error *ngIf="inputCpf.touched && inputCpf.getError('required')">
      Este campo é obrigatório!
    </mat-error>
    <mat-error *ngIf="inputCpf.touched && inputCpf.getError('documentIsInvalid')">
      Informe um CPF válido
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputDataNascimento.touched && inputDataNascimento?.errors">
    <mat-label>Data de Nascimento</mat-label>
    <input 
      matInput 
      name="inputDataNascimento"
      #inputDataNascimento="ngModel"
      [(ngModel)]="usuario.dataNascimento"
      class="custom-input"
      mascara="00/00/0000"
      placeholder="00/00/0000" 
      autocomplete="off"
      required
      >
    <mat-error *ngIf="inputDataNascimento.touched && inputDataNascimento?.errors?.required">
      Este campo é obrigatório!
    </mat-error>

    <mat-error *ngIf="inputDataNascimento.touched && inputDataNascimento?.errors?.invalidDate">
      Formato de data inválido
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputEmail.touched && inputEmail?.errors">
    <mat-label>Email</mat-label>
    <input 
      matInput
      name="inputEmail"
      #inputEmail="ngModel"
      [(ngModel)]="usuario.email"
      class="custom-input"
      placeholder="exemplo@exemplo.com" 
      autocomplete="off"
      type="email"
      pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
      >
      <mat-error *ngIf="inputEmail.touched && inputEmail?.errors?.pattern">
        Email inválido
      </mat-error>
  </mat-form-field>

  <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputTelefone.touched && inputTelefone?.errors">
    <mat-label>Telefone</mat-label>
    <input 
      matInput
      name="inputTelefone"
      #inputTelefone="ngModel"
      [(ngModel)]="usuario.telefone"
      class="custom-input"
      mascara="(00) 00000-0000"
      placeholder="(00) 00000-0000" 
      autocomplete="off"
      >
  </mat-form-field>

  <button 
    type="submit"
    [disabled]="(form.invalid || !emailOuTelefoneValido) || loading"
    class="fullwidth" 
    mat-raised-button
    color="primary">
    <mat-icon *ngIf="loading">
      <mat-spinner color="accent" diameter="20">
      </mat-spinner>
    </mat-icon>
    Continuar
  </button>

  <p>
    <a href="javascript:void(0)" (click)="irParaLogin()">Já possui uma conta? Fazer Login!</a>
  </p>
</form>